import { render, staticRenderFns } from "./MentionPicker.vue?vue&type=template&id=bbf1c680&scoped=true"
import script from "./MentionPicker.vue?vue&type=script&setup=true&lang=js"
export * from "./MentionPicker.vue?vue&type=script&setup=true&lang=js"
import style0 from "./MentionPicker.vue?vue&type=style&index=0&id=bbf1c680&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../account/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bbf1c680",
  null
  
)

export default component.exports